var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.step <= _vm.steps)?_c('div',[_c('ProgressBar',{attrs:{"index":_vm.step,"count":_vm.steps}}),_vm._v(" "),(1 == 2)?_c('div',[_c('button',{on:{"click":function($event){return _vm.navigatePrev()}}},[_vm._v("Prev")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.navigateNext()}}},[_vm._v("Next")])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e094ec3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 47
// module chunks = 0